import { useState, useEffect } from 'react'

export const useIsBrowserInit = () => {
  const [isInit, setIsInit] = useState(false)

  useEffect(() => setIsInit(true), [])

  return isInit
}
